import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-certificazioneISO',
  templateUrl: './certificazioneISO.component.html',
  styleUrls: ['./certificazioneISO.component.scss']
})
export class CertificazioneISOComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/certificazioneISO/certificazioneISO.component.ts